import React, { Component } from 'react';
import { connect } from 'react-redux';
import { exportPriceSheet } from '../../redux/actions';
import moment from 'moment';

 class GeneratePriceSheetDialog extends Component {

   constructor(props) {
    super(props);
    this.state = {
    };
  }


  handleCancel = (e) => {
    e.preventDefault();
    this.props.onClose && this.props.onClose();
  };

  handleContinue = (e) => {
    e.preventDefault();
    const self = this;
    let effectiveDate = self.getEffectiveDate();
    let selectedAgreementName = self.props.selectedAgreementName.filter(selectedAgreement => selectedAgreement.AGREEMENT_NUMBER == self.props.selectedSA);
    let draftRelation = self.props.user.relationShipPartyList.responseObject.filter(relationShipList => relationShipList.RELATIONSHIP_TYPE.includes("Draft"));
     const payload = {
            template_name : self.props.priceSheet.template_name,
            effective_date : self.props.priceSheet.effective_date,
            accountNumber : self.props.user.accountDetail.responseObject[0].ACCOUNTNUMBER,
            salesAgreement : self.props.selectedSA,
            emailId : self.props.user.userDetails.email,
            priceSheetRunDate: effectiveDate,
            accountName: self.props.user.accountDetail.responseObject[0].ORGANIZATIONNAME,
            agreementName: selectedAgreementName[0].AGREEMENT_NAME || self.props.user.selectedPriceSource.AGREEMENT_NAME,
            isDraft: draftRelation !== null && draftRelation.length > 0 ? true : false 
        }
     const payloadForApi = JSON.parse(JSON.stringify(payload));
            self.props.exportPriceSheet(payloadForApi, response => {
                self.setState({
                    isExportPriceSheetServiceCompleted : true
                });
            });
    this.props.onContinue && this.props.onContinue();
  };

  getEffectiveDate = () => {
    const { priceSheet } = this.props;
    if (!priceSheet || !priceSheet.effective_date) return null;
    const today = moment().startOf('day');
    const cycleDate = moment(priceSheet.effective_date, 'YYYY-MM-DD').startOf('day');
    const maxDate = today.isAfter(cycleDate) ? today : cycleDate;
    return maxDate.format('YYYY-MM-DD');
  };

  render() {
    const { open } = this.props;
    const effectiveDate = this.getEffectiveDate();

    return (
      <div
        className={"overlayDialog " + (open ? "visible" : "hide")} id="generatePriceSheetDialog" >
        <div className="blackoutLayer"></div>
        <div className="overlayDialogWindow">
          <h2 className="title">Generate Price Sheet</h2>
          <p>
            The selected price sheet will be generated with an effective date
            of {effectiveDate} and sent via email.
          </p>
          <div className="noButtonContainer"><a className="noButton blueButton" onClick={this.handleCancel}> Cancel </a></div>
          <div className="yesButtonContainer"><a className="yesButton blueButton" onClick={this.handleContinue}>Continue</a></div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return { state };
};

const mapDispatchToProps = (dispatch) => ({
    exportPriceSheet : (payload, callback) => dispatch(exportPriceSheet(payload, callback))
});

GeneratePriceSheetDialog = connect(mapStateToProps, mapDispatchToProps)(GeneratePriceSheetDialog);
export default GeneratePriceSheetDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/generatePriceSheetDialog.js